import { neutral } from '@bloomfieldrobotics/canopy';
import {
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
  styled,
  tooltipClasses,
} from '@mui/material';

export const Tooltip = styled(({ className, ...props }: MuiTooltipProps) => (
  <MuiTooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: neutral[700],
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: neutral[700],
  },
}));
